import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { toast } from "sonner";
import { imgUrl, formatApiErrorDetail } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { useSettings } from "../../context/SettingsContext";

export default function AdminLogin() {
  const { login } = useAuth();
  const { settings } = useSettings();
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@katirtzoglou-pharmacy.gr");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      if (u.role !== "admin") {
        toast.error("Δεν έχετε δικαιώματα διαχειριστή");
        return;
      }
      toast.success("Καλώς ήρθατε");
      nav("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Σφάλμα σύνδεσης");
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full px-4 py-3 rounded-sm border border-[#2c4d40] bg-[#16271f] text-white text-sm focus:border-[#CBD9B6] focus:ring-1 focus:ring-[#CBD9B6] outline-none placeholder:text-[#7d9387]";

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#1E3A2F] px-6">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <img src={imgUrl(settings?.logo || "/logo.jpeg")} alt="logo" className="h-16 w-16 rounded-md object-cover mx-auto mb-4" />
          <h1 className="font-serif-display text-3xl text-white">Πίνακας Διαχείρισης</h1>
          <p className="text-[#CBD9B6] mt-1 text-sm">Φαρμακείο Κατιρτζόγλου</p>
        </div>
        <form onSubmit={submit} className="space-y-4 bg-[#16271f] border border-[#2c4d40] rounded-sm p-6">
          <input data-testid="admin-email" type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} required />
          <input data-testid="admin-password" type="password" placeholder="Κωδικός" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} required />
          <button data-testid="admin-login-submit" disabled={loading} className="w-full bg-[#CBD9B6] text-[#1E3A2F] py-3 rounded-sm font-semibold hover:bg-white transition-colors disabled:opacity-60 flex items-center justify-center gap-2">
            <Lock className="h-4 w-4" /> {loading ? "Σύνδεση..." : "Είσοδος"}
          </button>
        </form>
      </div>
    </div>
  );
}
